import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
// import ChangeableHeader from "../../Molecules/ChangeableHeader/ChangeableHeader";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";
import SuccessCasesCardsSection from "../../Organisms/SuccessCasesCardsSection/SuccessCasesCardsSection";
import content from "./content";

const SuccessCases = () => {
	const { dropdownHeader } = useScrollCtx();
	const { language } = useLanguageCtx();

	return (
		<>
			<ChangeableHeaderV2
        appearSecondNavbar={dropdownHeader}
        titleBanner={content[language].header_title}
        spanTitleYellow={content[language].header_span_title}
      />
			<div className="max-width">
				<h2 className="t2 center-text no-space top-space-section bottom-space-section">
					{content[language].title}
				</h2>
				<SuccessCasesCardsSection />
			</div>
		</>
	);
};

export default SuccessCases;
